import { inject, Component, computed } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthStatusType } from '../services/auth/auth-state.service';
import { MDB_AUTH_STATUS } from '../services/auth/tokens';
import { DirectLinkDetailsService } from '../services/direct-link/direct-link-details/direct-link-details.service';
import { MDB_VIRTUAL_SITE } from '../services/virtual-site/virtual-site.service';

@Component({
  selector: 'app-footer',
  imports: [RouterModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  site = inject(MDB_VIRTUAL_SITE);
  directLinkDetailsService = inject(DirectLinkDetailsService);
  authStatus = inject(MDB_AUTH_STATUS);

  protected isAuthDirectLink = computed(() => {
    return (
      this.directLinkDetailsService.getDirectLinkDetails()?.isSuccess &&
      this.authStatus() === AuthStatusType.Authenticated &&
      this.directLinkDetailsService.getDirectLinkDetails()?.destination !==
        'ExternalPayment' &&
      this.directLinkDetailsService.getDirectLinkDetails()?.destination !==
        'TOSPayment'
    );
  });

  protected unAuthDirectLink = computed(() => {
    return this.directLinkDetailsService.getDirectLinkDetails()?.isSuccess;
  });

  termsOfUseUrl: string =
    this.site.settings.links.termsOfUse ??
    'https://dcsokk5etzbbl.cloudfront.net/Pxp/terms-of-use.html';

  privacyPolicyUrl: string =
    this.site.settings.links.privacyPolicy ??
    'https://dcsokk5etzbbl.cloudfront.net/Pxp/privacy-policy.html';

  languageAssistanceUrl: string =
    this.site.settings.links.languageAssistance ??
    'https://dcsokk5etzbbl.cloudfront.net/Pxp/language-assistance.pdf';
}
